import { FC } from 'react';

import { Button } from '@gds/Button/Button';
import Link from 'next/link';

type Props = {
  ctaData: any;
  className?: string;
  fullWidth?: boolean;
  variant?: 'outlined' | 'link' | 'contained' | undefined;
};

const Cta: FC<Props> = ({ ctaData = [], ...buttonProps }) => {
  const {
    elements: {
      cta_text: { value: ctaText },
      link: { value: ctaLink },
    },
  } = ctaData;

  return (
    <Button Component={Link} href={ctaLink} {...buttonProps}>
      {ctaText}
    </Button>
  );
};

export default Cta;
